import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskService } from 'src/app/services/task.service';
import { environment } from 'src/environments/environment';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { Enums } from 'src/app/helpers/enums';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';

declare var $: any;

@Component({
  selector: 'app-activated-task-kanban',
  templateUrl: './activated-task-kanban.component.html',
  styleUrls: ['./activated-task-kanban.component.css']
})
export class ActivatedTaskKanbanComponent implements OnInit {

  public environmentSettings: any;
  activatedTaskData: any = [];
  taskStatusTypes: any[];
  
  // Kanban columns
  pendingTasks: any[] = [];
  completedTasks: any[] = [];
  delayedTasks: any[] = [];
  partiallyCompletedTasks: any[] = [];
  naTasks: any[] = [];
  doneTasks: any[] = [];
  cancelledTasks: any[] = [];
  
  isLoading: boolean = true;
  draggedTask: any = null;
  selectedTaskForView: any = null;

  constructor(
    private taskService: TaskService,
    private commonFunction: CommonFunction,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.taskStatusTypes = this.commonFunction.sortByKey(Enums.TaskStatus, 'name');
    this.environmentSettings = environment;
  }

  ngOnInit() {
    this.getActivatedTaskList();
  }

  getActivatedTaskList() {
    this.isLoading = true;
    let usersList = this.taskService.getUsersList();
    let activatedTaskList = this.taskService.getActivatedTaskList();

    Observable.forkJoin([activatedTaskList, usersList])
      .subscribe((response: any) => {
        this.activatedTaskData = response[0].taskList;
        let usersData = response[1].result;

        var activatedtasksData = [];

        // AssignedTo , CreatedBy 
        _.forEach(this.activatedTaskData, function (activatedTask) {
          let assignedUserName = [];
          if (activatedTask.AssignedTo && activatedTask.AssignedTo.length > 0) {
            activatedTask.AssignedTo.forEach((ele) => {
              var assignedTo = _.filter(usersData, ["_id", ele]);
              if (assignedTo && assignedTo.length > 0) {
                assignedUserName.push(assignedTo[0].FirstName + " " + assignedTo[0].LastName)
              }
            })
          }
          activatedTask.AssignedUserName = assignedUserName.join(', ');

          if (activatedTask.CreatedBy != undefined) {
            var createdBy = _.filter(usersData, ["_id", activatedTask.CreatedBy]);
            if (createdBy.length) {
              activatedTask.Owner = createdBy[0].FirstName + " " + createdBy[0].LastName;
            }
          }

          if (activatedTask.CategoryName == undefined) {
            activatedTask.CategoryName = "";
          }
          if (activatedTask.ProcessName == undefined) {
            activatedTask.ProcessName = "";
          }

          activatedtasksData.push(activatedTask);
        });

        this.activatedTaskData = activatedtasksData;
        this.categorizeTasksByStatus();
        this.isLoading = false;
      }, error => {
        console.error('Error fetching tasks:', error);
        this.isLoading = false;
      });
  }

  categorizeTasksByStatus() {
    this.pendingTasks = [];
    this.completedTasks = [];
    this.delayedTasks = [];
    this.partiallyCompletedTasks = [];
    this.naTasks = [];
    this.doneTasks = [];
    this.cancelledTasks = [];

    this.activatedTaskData.forEach(task => {
      switch (task.TaskStatus) {
        case 1:
          this.pendingTasks.push(task);
          break;
        case 2:
          this.completedTasks.push(task);
          break;
        case 3:
          this.delayedTasks.push(task);
          break;
        case 4:
          this.partiallyCompletedTasks.push(task);
          break;
        case 5:
          this.naTasks.push(task);
          break;
        case 6:
          this.doneTasks.push(task);
          break;
        case 7:
          this.cancelledTasks.push(task);
          break;
      }
    });
  }

  getStatusColor(status: number): string {
    switch (status) {
      case 1: return '#ffc107'; // Pending - amber
      case 2: return '#28a745'; // Completed - green
      case 3: return '#dc3545'; // Delayed - red
      case 4: return '#17a2b8'; // Partially Completed - teal
      case 5: return '#6c757d'; // NA - gray
      case 6: return '#20c997'; // Done - success green
      case 7: return '#343a40'; // Cancelled - dark
      default: return '#6c757d';
    }
  }

  getStatusName(statusId: number): string {
    const status = this.taskStatusTypes.find(s => s.id == statusId.toString());
    return status ? status.name : '';
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  onDragStart(event: DragEvent, task: any, currentStatus: number) {
    this.draggedTask = { task, currentStatus };
    event.dataTransfer!.effectAllowed = 'move';
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'move';
  }

  onDrop(event: DragEvent, newStatus: number) {
    event.preventDefault();
    if (this.draggedTask && this.draggedTask.currentStatus !== newStatus) {
      // Update task status
      this.draggedTask.task.TaskStatus = newStatus;
      this.categorizeTasksByStatus();
      
      // Here you would typically call a service to update the task on the backend
      // this.taskService.updateTaskStatus(this.draggedTask.task._id, newStatus).subscribe(...);
    }
    this.draggedTask = null;
  }

  viewTaskDetails(task: any) {
    // Open modal with task details
    this.selectedTaskForView = task;
    console.log('Viewing task:', task);
    // Use jQuery to show the modal (Bootstrap 4 compatible)
    $('#taskDetailsModal').modal('show');
  }

  closeTaskDetailsModal() {
    $('#taskDetailsModal').modal('hide');
    this.selectedTaskForView = null;
  }

  refreshKanban() {
    this.getActivatedTaskList();
  }

  getTaskCount(statusId: number): number {
    switch (statusId) {
      case 1: return this.pendingTasks.length;
      case 2: return this.completedTasks.length;
      case 3: return this.delayedTasks.length;
      case 4: return this.partiallyCompletedTasks.length;
      case 5: return this.naTasks.length;
      case 6: return this.doneTasks.length;
      case 7: return this.cancelledTasks.length;
      default: return 0;
    }
  }

  getTasksByStatus(statusId: number): any[] {
    switch (statusId) {
      case 1: return this.pendingTasks;
      case 2: return this.completedTasks;
      case 3: return this.delayedTasks;
      case 4: return this.partiallyCompletedTasks;
      case 5: return this.naTasks;
      case 6: return this.doneTasks;
      case 7: return this.cancelledTasks;
      default: return [];
    }
  }

  back() {
    this.router.navigate([{ outlets: { 'structure-outlet': 'tasks/activated' } }]);
  }

  truncateTaskName(name: string, maxLength: number = 35): string {
    if (!name) return '';
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + '...';
  }

  exportToExcel() {
    const workbook = XLSX.utils.book_new();

    // Helper function to prepare task data for export
    const prepareTaskData = (tasks: any[]) => {
      return tasks.map(task => ({
        'Task Name': task.TaskName || '',
        'Description': task.Description || '',
        'Due Date': this.formatDate(task.DueDate),
        'Completed Date': this.formatDate(task.CompletedDate),
        'Assigned To': task.AssignedUserName || '',
        'Owner': task.Owner || '',
        'Category': task.CategoryName || '',
        'Process': task.ProcessName || '',
        'Status': this.getStatusName(task.TaskStatus),
        'Remarks': task.Remarks || '',
        'Created Date': this.formatDate(task.CreatedDate),
        'Email Contents': task.EmailContents || ''
      }));
    };

    // Create sheets for each status
    if (this.pendingTasks.length > 0) {
      const pendingData = prepareTaskData(this.pendingTasks);
      const pendingSheet = XLSX.utils.json_to_sheet(pendingData);
      XLSX.utils.book_append_sheet(workbook, pendingSheet, 'Pending');
    }

    if (this.completedTasks.length > 0) {
      const completedData = prepareTaskData(this.completedTasks);
      const completedSheet = XLSX.utils.json_to_sheet(completedData);
      XLSX.utils.book_append_sheet(workbook, completedSheet, 'Completed');
    }

    if (this.delayedTasks.length > 0) {
      const delayedData = prepareTaskData(this.delayedTasks);
      const delayedSheet = XLSX.utils.json_to_sheet(delayedData);
      XLSX.utils.book_append_sheet(workbook, delayedSheet, 'Delayed');
    }

    if (this.partiallyCompletedTasks.length > 0) {
      const partiallyCompletedData = prepareTaskData(this.partiallyCompletedTasks);
      const partiallyCompletedSheet = XLSX.utils.json_to_sheet(partiallyCompletedData);
      XLSX.utils.book_append_sheet(workbook, partiallyCompletedSheet, 'Partially Completed');
    }

    if (this.doneTasks.length > 0) {
      const doneData = prepareTaskData(this.doneTasks);
      const doneSheet = XLSX.utils.json_to_sheet(doneData);
      XLSX.utils.book_append_sheet(workbook, doneSheet, 'Done');
    }

    if (this.naTasks.length > 0) {
      const naData = prepareTaskData(this.naTasks);
      const naSheet = XLSX.utils.json_to_sheet(naData);
      XLSX.utils.book_append_sheet(workbook, naSheet, 'NA');
    }

    if (this.cancelledTasks.length > 0) {
      const cancelledData = prepareTaskData(this.cancelledTasks);
      const cancelledSheet = XLSX.utils.json_to_sheet(cancelledData);
      XLSX.utils.book_append_sheet(workbook, cancelledSheet, 'Cancelled');
    }

    // Create summary sheet
    const summaryData = [
      { 'Status': 'Pending', 'Count': this.pendingTasks.length },
      { 'Status': 'Completed', 'Count': this.completedTasks.length },
      { 'Status': 'Delayed Completion', 'Count': this.delayedTasks.length },
      { 'Status': 'Partially Completed', 'Count': this.partiallyCompletedTasks.length },
      { 'Status': 'Done', 'Count': this.doneTasks.length },
      { 'Status': 'NA', 'Count': this.naTasks.length },
      { 'Status': 'Cancelled', 'Count': this.cancelledTasks.length },
      { 'Status': 'Total', 'Count': this.activatedTaskData.length }
    ];
    const summarySheet = XLSX.utils.json_to_sheet(summaryData);
    XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');

    // Generate file name with current date
    const date = new Date();
    const fileName = `Activated_Tasks_Kanban_${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}.xlsx`;

    // Save the file
    XLSX.writeFile(workbook, fileName);
  }
}

